"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _semanticUiReact = require("semantic-ui-react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultValuesBuilder = function DefaultValuesBuilder(_ref) {
  var store = _ref.store;

  var handleRemoveDefaultValue = function handleRemoveDefaultValue(defaultValue) {
    store.removeDefaultValue(defaultValue.id);
  };

  var handleEditDefaultValueKey = function handleEditDefaultValueKey(e, defaultValue) {
    store.editDefaultValueKey(defaultValue.id, e.target.value);
  };

  var handleEditDefaultValue = function handleEditDefaultValue(e, defaultValue) {
    store.editDefaultValue(defaultValue.id, e.target.value);
  };

  var handleSetDefaultValueNull = function handleSetDefaultValueNull(defaultValue, value) {
    store.editDefaultValue(defaultValue.id, value);
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      minHeight: 83
    }
  }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid, {
    padded: true,
    columns: "equal"
  }, store.defaultValues.map(function (defaultValue) {
    return /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Row, {
      key: defaultValue.id,
      verticalAlign: "middle"
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 16,
      computer: 7
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, {
      style: {
        minHeight: 90
      }
    }, /*#__PURE__*/_react.default.createElement("label", null, "Llave"), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Input, {
      onChange: function onChange(e) {
        handleEditDefaultValueKey(e, defaultValue);
      },
      onBlur: function onBlur(e) {
        handleEditDefaultValueKey(e, defaultValue);
      },
      size: "tiny",
      type: "text",
      value: defaultValue.key
    }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 16,
      computer: 7
    }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Field, null, /*#__PURE__*/_react.default.createElement("label", null, "Valor"), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form.Input, {
      onChange: function onChange(e) {
        handleEditDefaultValue(e, defaultValue);
      },
      onBlur: function onBlur(e) {
        handleEditDefaultValue(e, defaultValue);
      },
      size: "tiny",
      type: "text",
      value: defaultValue.value ? defaultValue.value : "",
      disabled: defaultValue.value === null
    })), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Checkbox, {
      label: "Es nulo",
      toggle: true,
      defaultChecked: defaultValue.value === null,
      onChange: function onChange(evt, _ref2) {
        var checked = _ref2.checked;
        handleSetDefaultValueNull(defaultValue, checked ? null : "");
      }
    }))), /*#__PURE__*/_react.default.createElement(_semanticUiReact.Grid.Column, {
      tablet: 8,
      computer: 2,
      textAlign: "center"
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Button, {
      icon: true,
      onClick: function onClick() {
        handleRemoveDefaultValue(defaultValue);
      }
    }, /*#__PURE__*/_react.default.createElement(_semanticUiReact.Icon, {
      name: "remove circle",
      size: "large"
    }))));
  }))));
};

var _default = DefaultValuesBuilder;
exports.default = _default;